import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import * as firebaseui from 'firebaseui';
import {injectable} from 'inversify';
import {lazyInject, TYPES} from '../utils/inversify-config';
import {Store} from 'react-redux';
import MeepoState from '../reduxstore/meepo-state';
import UserClient from './user-client';

@injectable()
export class FirebaseClient {

    private readonly app;
    private readonly db;
    private readonly ui;

    @lazyInject(TYPES.REDUX_STORE)
    public store: Store<MeepoState>;

    @lazyInject(TYPES.USER_SERVICE)
    public userService: UserClient;

    constructor() {
        const config = {
            apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY}`,
            authDomain: `${process.env.REACT_APP_FIREBASE_AUTH_DOMAIN}`,
            databaseURL: `${process.env.REACT_APP_FIREBASE_DATABASE_URL}`,
            projectId: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
            messagingSenderId: `${process.env.REACT_APP_FIREBASE_MESSAGING_SENDER}`,
        };

        this.app = firebase.initializeApp(config);
        const fireStoreSettings = {/* your settings... */ timestampsInSnapshots: true};

        this.db = firebase.firestore(this.app);
        this.db.settings(fireStoreSettings);

        this.ui = new firebaseui.auth.AuthUI(firebase.auth());
    }

    public startFirebaseUi(elementId: string) {
        this.ui.start(elementId, {
            signInOptions: [
                {
                    provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                }
            ],
            signInSuccessUrl: '/home',
            credentialHelper: firebaseui.auth.CredentialHelper.NONE
        })
    }

    public getApp() {
        return this.app;
    }

    public getDb() {
        return this.db;
    }

}

export default FirebaseClient;


// WEBPACK FOOTER //
// ./src/middleware/firebase.ts